export const ZapVoltage = () => {
  return <span className="step-icon">⚡</span>
}
